(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientTypeSearch', PatientTypeSearch);

    PatientTypeSearch.$inject = ['$resource'];

    function PatientTypeSearch($resource) {
        var resourceUrl =  'api/_search/patient-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
